<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<h1 class="chaptertitle ">PART I</h1>
<h2 class="chaptersubtitle ">FAITH</h2>
<blockquote class="margin">
<p class="center "><em>Skepticism is the beginning of faith.</em></p>
<p class="center ">—<span class="smallcaps">OSCAR WILDE</span></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?2f6681e0